import { AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { ConfigApi } from '../api/config.api';
import {
  fetchConfig,
  fetchConfigFailed,
  fetchConfigSucceeded,
} from '../slices/config.slice';

export const getPublicConfigThunk = (
  code: string,
): AppThunk<Promise<any>> => async (dispatch: Dispatch) => {
  let response: AxiosResponse<{
    title: string;
    btnText: string;
    btnLink: string;
    backgroundImage: any;
  }> = null;
  dispatch(fetchConfig());

  try {
    response = await ConfigApi.getPublicConfig(code);

    dispatch(
      fetchConfigSucceeded({ key: 'public', data: { [code]: response.data } }),
    );
    return response.data;
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;

    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
      config: null,
      toJSON: null,
    };
    dispatch(fetchConfigFailed(error));
    throw error;
  }
};
